module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cm6Xe"))).then(() => parcelRequire('hEqeo'));